const Selector = function(settings) {
	"use strict";

	const _self = this;
	const _settings = {
		currentId: null,
		animating: false,
		deactivating: false
	};

	Object.assign(_settings, settings);

	function cacheDom() {}

	function bindEvents() {
		_settings.$el.addEventListener("change", selectSection);
	}

	function selectSection(e) {
		e.preventDefault();

		window.location.href = e.target.options[e.target.selectedIndex].value;
	}

	function selectOption() {
		_settings.$el.querySelectorAll("option").forEach((el) => {
			if (window.location.href.includes(el.value)) {
				el.selected = true;
			}
		});
	}

	function init() {
		cacheDom();
		bindEvents();

		selectOption();

		return _self;
	}

	return init();
};

export { Selector };
